// src/components/solutions/SolutionsImperative.tsx
import React from 'react';
import { ContentCard } from '@dopomogai/ui';
import { Badge } from '@dopomogai/ui';
import {Button} from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

interface Pillar {
  icon: string;
  title: string;
  text: string;
}

interface ImperativeData {
  headline: string;
  intro: string;
  pillars: Pillar[];
  impactCallout: {
    headline: string;
    text: string;
    cta: string;
  };
}

interface SolutionsImperativeProps {
  imperativeData: ImperativeData;
  onAction: (actionType: string, payload?: any) => void;
}

export const SolutionsImperative: React.FC<SolutionsImperativeProps> = ({ imperativeData, onAction }) => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{imperativeData.headline}</h2>
          <p className="mt-4 text-lg text-slate-600">{imperativeData.intro}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {imperativeData.pillars.map((pillar, index) => (
            <ContentCard
              key={index}
              index={index}
              icon={renderIcon(pillar.icon, { size: 28, className: "text-emerald-500" })}
              title={pillar.title}
              text={pillar.text}
              hoverEffect="lift"
              iconContainerClassName="p-3 bg-emerald-50 border-2 border-black rounded-lg w-fit"
            />
          ))}
        </div>

        <div className="mt-16 bg-slate-50 border-2 border-black rounded-xl p-8 md:p-10 text-center max-w-4xl mx-auto">
          <div className="flex justify-center mb-4">
             <Badge text="Impact-Parity™ Program" accentColor="green" icon="heart" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900">{imperativeData.impactCallout.headline}</h3>
          <p className="mt-3 text-slate-600 max-w-3xl mx-auto">{imperativeData.impactCallout.text}</p>
          <div className="mt-6">
            <Button
              text={imperativeData.impactCallout.cta}
              variant="ghost"
              onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/vision' })}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

